import { CoherenceDataGrid } from "@coherence-design-system/controls";
import React, { useEffect, useMemo, useState } from "react";
import { CustomerService } from "../../services/Customers/CustomerService";
import {
  IObjectWithKey,
  SelectionMode,
  Selection,
  Spinner,
  SpinnerSize,
  Stack,
  List,
} from "@fluentui/react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import {
  CustomerAccountInfo,
  ResponseCustomerEditAccount as CustomerInfo,
} from "./Customer.types";
import { customerInfoIntialValue as intialValue } from "./CustomerFormInitialValues";
import {
  DefaultCurrentPage,
  DefaultCurrentPageSize,
  DefaultTotalPages,
} from "../Quotation/Common/QuotationData";
import PaginationComponent from "../Quotation/Components/PaginationComponent";
import { LinkProps } from "react-router-dom";
import { TDataGridColumn } from "@coherence-design-system/data-grid";
interface IAccountsProps {
  region: string;
  searchRegion: string[];
  setSearchResultCount: React.Dispatch<React.SetStateAction<number>>;
  searchText: string;
  selection: Selection<IObjectWithKey>;
  selectedGridData: {
    items: any[];
  };
  setIsAddButtonDisabled: any;
}
export interface ICustomerPayload {
  region: string;
  records: number;
  skip: number;
  searchText: string;
  customerRegion: string[];
}

export interface CustomerData extends CustomerAccountInfo {
  key: number;
  primaryContact?: string;
}

interface ListConfigItem {
  fieldName: string;
  isResizable: boolean;
  key: string;
  name: string;
  type: string;
  url?: string;
  linkProps?: LinkProps;
  onRender?: (item: any) => JSX.Element;
}

export const CustomerList: React.FunctionComponent<IAccountsProps> = (
  props
) => {
  // Assign selectedValue from props.selectedGridData if available, otherwise use initialValue
  const selectedValue: CustomerInfo = (props.selectedGridData?.items?.[0] as CustomerInfo) ?? intialValue;
  const appInsights = useAppInsightsContext();
  const navigate = useNavigate();
  const [isToggle, setisDeletedToggle] = useState(false);
  const [isDeletedItem, setIsDeletedItem] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [customerData, setCustomerData] = useState<CustomerData[]>([]);
  const [selectedGridData, setSelectedGridData] = useState<{
    items: any[];
  }>({ items: [] });
  const [columnsList, setColumnsList] = useState<ListConfigItem[]>();
  const [totalPages, setTotalPages] = useState<number>(DefaultTotalPages);
  const [currentPage, setCurrentPage] = useState<number>(DefaultCurrentPage);
  const [currentPageSize, setCurrentPageSize] = useState<number>(
    DefaultCurrentPageSize
  );
  let skip = (currentPage - 1) * currentPageSize;
  const region = props.region;
  const customerDataCount = customerData?.filter(
    (x) => x?.accountId !== ""
  )?.length;
  // const customerSelection = useMemo(
  //   () =>
  //     new Selection({
  //       onSelectionChanged: () => {
  //         const selectedCustomer = customerSelection.getSelection();
  //         console.log("selectedCustomer under memo",selectedCustomer)
  //         if (selectedCustomer?.length) {
  //          // props.setSelectedGridData({ items: selectedCustomer });
  //
  //         }
  //       },
  //     }),

  //   [JSON.stringify(customerData)]
  // );

  React.useMemo(() => {
    const listConfig = [
      {
        fieldName: "accountId",
        isResizable: true,
        key: "account",
        name: "Customer Account",
        type: "link",
        url: "",
        linkProps: {
          onClick: () => onClickAccountId(),
          role: "link", // Specify a role for screen reader users
          tabIndex: 0,
          style: { textDecoration: "underline" },
        },
        maxWidth: 180,
      },
      {
        fieldName: "name",
        isResizable: true,
        key: "name",
        name: "Customer Name",
        type: "link",
        url: "",
        linkProps: {
          onClick: () => onClickAccountId(),
          role: "link", // Specify a role for screen reader users
          tabIndex: 0,
          style: { textDecoration: "underline" },
        },
        maxWidth: 300,
      },
      {
        fieldName: "primaryContact",
        key: "contacts",
        name: "Primary Contact",
        isResizable: true,
        type: "string",
        // onRender: (item: any) => (
        //   <span style={{ fontSize: "14px", color: "rgb(50, 49, 48)" }}>
        //     {item.authorizedBuyerFirstName} {item.authorizedBuyerLastName}
        //   </span>
        // ),
        maxWidth: 200,
      },
      {
        fieldName: "authorizedEmailId",
        isResizable: true,
        key: "authorizedEmailId",
        name: "Email",
        type: "string",
        maxWidth: 160,
      },
      {
        fieldName: "authorizedBuyerPhone",
        isResizable: true,
        key: "telephone",
        name: "Phone",
        type: "string",
        maxWidth: 140,
      },
      {
        fieldName: "country",
        isResizable: true,
        key: "region",
        name: "Country",
        type: "string",
        maxWidth: 140,
      },
      {
        fieldName: "createdDate",
        isResizable: true,
        key: "createdDate",
        name: "Created On",
        type: "string",
        onRender: (item: any) => (
          <span style={{ fontSize: "14px", color: "rgb(50, 49, 48)" }}>
            {new Date(item.createdDate)
              .toLocaleString("en-US", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false,
              })
              .replace(
                /(\d+)\/(\d+)\/(\d+), (\d+):(\d+):(\d+)/,
                "$2-$1-$3 $4:$5:$6"
              )}
          </span>
        ),
      },
    ];

    setColumnsList(listConfig as ListConfigItem[]);
  }, [customerData, JSON.stringify(props.selectedGridData?.items)]);

  React.useMemo(() => {
    const listConfig = [
      {
        fieldName: "accountId",
        isResizable: true,
        key: "account",
        name: "Customer Account",
        type: "link",
        url: "",
        linkProps: {
          onClick: () => onClickAccountId(),
          role: "link", // Specify a role for screen reader users
          tabIndex: 0,
          style: { textDecoration: "underline" },
        },
        maxWidth: 180,
      },
      {
        fieldName: "name",
        isResizable: true,
        key: "name",
        name: "Customer Name",
        type: "link",
        url: "",
        linkProps: {
          onClick: () => onClickAccountId(),
          role: "link", // Specify a role for screen reader users
          tabIndex: 0,
          style: { textDecoration: "underline" },
        },
        maxWidth: 300,
      },
      {
        fieldName: "primaryContact",
        key: "contacts",
        name: "Primary Contact",
        isResizable: true,
        type: "string",
        // onRender: (item: any) => (
        //   <span style={{ fontSize: "14px", color: "rgb(50, 49, 48)" }}>
        //     {item.authorizedBuyerFirstName} {item.authorizedBuyerLastName}
        //   </span>
        // ),
        maxWidth: 200,
      },
      {
        fieldName: "authorizedEmailId",
        isResizable: true,
        key: "authorizedEmailId",
        name: "Email",
        type: "string",
        maxWidth: 160,
      },
      {
        fieldName: "authorizedBuyerPhone",
        isResizable: true,
        key: "telephone",
        name: "Phone",
        type: "string",
        maxWidth: 140,
      },
      {
        fieldName: "country",
        isResizable: true,
        key: "region",
        name: "Country",
        type: "string",
        maxWidth: 140,
      },
      {
        fieldName: "createdDate",
        isResizable: true,
        key: "createdDate",
        name: "Created On",
        type: "string",
        onRender: (item: any) => (
          <span style={{ fontSize: "14px", color: "rgb(50, 49, 48)" }}>
            {new Date(item.createdDate)
              .toLocaleString("en-US", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false,
              })
              .replace(
                /(\d+)\/(\d+)\/(\d+), (\d+):(\d+):(\d+)/,
                "$2-$1-$3 $4:$5:$6"
              )}
          </span>
        ),
      },
    ];

    setColumnsList(listConfig as []);
  }, [customerData, JSON.stringify(props.selectedGridData?.items)]);

  useEffect(() => {
    setIsLoading(false);
    if (isDeletedItem) {
      selectedValue &&
        CustomerService.deleteCustomerAccount(
          selectedValue.id,
          selectedValue.id
        )
          .then((res) => {
            if (res !== undefined) {
              const customerPayload: ICustomerPayload = {
                records: 1000,
                skip: 0,
                searchText: props.searchText,
                region: props.region,
                customerRegion: props.searchRegion,
              };
              CustomerService.getAllCustomerAccountsInfo(customerPayload)
                .then((res) => {
                  setIsLoading(false);
                  if (res !== undefined) {
                    const totalSize: number = parseInt(
                      res?.data?.data?.totalCount
                    );
                    props.setSearchResultCount(totalSize);

                    const modifiedData =
                      res?.data?.data?.data?.map(
                        (x: CustomerInfo, index: number) => {
                          x.primaryContact = `${x.authorizedBuyerFirstName} ${x.authorizedBuyerLastName}`;
                          return {
                            ...x,
                            key: index,
                          };
                        }
                      ) ?? [];
                    const totalPage: number = Number(
                      (totalSize / currentPageSize).toFixed(0)
                    );
                    if (
                      totalSize < totalPage * currentPageSize ||
                      totalSize % currentPageSize === 0
                    ) {
                      setTotalPages(totalPage);
                    } else if (totalSize % currentPageSize !== 0) {
                      setTotalPages(totalPage + 1);
                    }
                    setCustomerData(modifiedData as CustomerData[]);
                  }
                })
                .catch((error) => {
                  appInsights.trackException({
                    error: new Error(error as string),
                    properties: {
                      name: "Error in GetCustomer API in Customer.tsx",
                    },
                  });
                  setIsLoading(false);
                });
            } else {
              setIsLoading(false);
            }
          })
          .catch((error) => {
            appInsights.trackException({
              error: new Error(error as string),
              properties: {
                name: "Error in Delete Customer API in Customer.tsx",
              },
            });
            setIsLoading(false);
          });
      setIsDeletedItem(false);
    } else {
      // if (props.searchText !== "NA" && searchCount === 0) {
      //   skip = searchCount;
      //   setSearchCount(1);
      // } else if (props.searchText === "NA") {
      //   setSearchCount(0);
      // }
      setIsDeletedItem(false);
      setIsLoading(true);
      const customerPayload: ICustomerPayload = {
        records: currentPageSize,
        skip: (currentPage - 1) * currentPageSize,
        searchText: props.searchText,
        region: props.region,
        customerRegion: props.searchRegion,
      };
      CustomerService.getAllCustomerAccountsInfo(customerPayload)
        .then((res) => {
          setIsLoading(false);
          if (res !== undefined) {
            const modifiedData =
              res?.data?.data?.data?.map((x: CustomerInfo, index: number) => {
                x.primaryContact = `${x.authorizedBuyerFirstName} ${x.authorizedBuyerLastName}`;
                x.createdDate = x.createdDate
                  ? new Date(x.createdDate)
                      .toLocaleString("en-US", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: false,
                      })
                      .replace(
                        /(\d+)\/(\d+)\/(\d+), (\d+):(\d+):(\d+)/,
                        "$3-$1-$2 $4:$5:$6"
                      )
                  : x.createdDate;

                return {
                  ...x,
                  key: index,
                };
              }) ?? [];
            const totalSize: number = parseInt(res?.data?.data?.totalCount);
            props.setSearchResultCount(totalSize);
            const totalPage: number = Number(
              (totalSize / currentPageSize).toFixed(0)
            );
            if (
              totalSize < totalPage * currentPageSize ||
              totalSize % currentPageSize === 0
            ) {
              setTotalPages(totalPage);
            } else if (totalSize % currentPageSize !== 0) {
              setTotalPages(totalPage + 1);
            }
            // if (res.data.data.data.length > 0) {
            //   props.setIsAddButtonDisabled(true);
            // } else {
            //   props.setIsAddButtonDisabled(false);
            // }

            setCustomerData(modifiedData as CustomerData[]);
          }
        })
        .catch((error) => {
          appInsights.trackException({
            error: new Error(error as string),
            properties: { name: "Error in GetCustomer API in Customer.tsx" },
          });
          setIsLoading(false);
        });
    }
  }, [navigate, isToggle, currentPage, currentPageSize, props.searchText]);

  const onClickAccountId = () => {
    console.log("under click");
    if (props.selectedGridData?.items?.length) {
      navigate("/CustomerEditContact", {
        state: props.selectedGridData?.items[0],
      });
    }
  };

  if (isLoading) {
    return <Spinner size={SpinnerSize.large} />;
  }

  return (
    <>
      {customerDataCount > 0 && (
        <CoherenceDataGrid
          styles={{ root: { minHeight: "250px", marginLeft: "20px" } }}
          ariaLabelForSelectAllCheckbox="select all checkbox"
          checkButtonAriaLabel="checkbox"
          checkboxVisibility={1}
          compactMode="compact"
          data={customerData as never[]}
          isScrollable
          isSortable
          initialSortedColumn="createdDate"
          listConfig={columnsList as []}
          invertInitialSort
          selection={props.selection}
          selectionMode={SelectionMode.single}
          selectionPreservedOnEmptyClick
          setKey="DATA_GRID_SORTABLE_SELECTABLE"
        />
      )}
      {customerDataCount === 0 && (
        <div
          style={{ marginLeft: "40vw", marginTop: "10vw", fontSize: "14px" }}
        >
          No Record Found
        </div>
      )}
      {!isLoading && customerDataCount > 0 && (
        <Stack style={{ marginBottom: "25px" }}>
          <PaginationComponent
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            currentPageSize={currentPageSize}
            setCurrentPageSize={setCurrentPageSize}
            totalPages={totalPages}
          />
        </Stack>
      )}
    </>
  );
};

